import { Box, Typography } from "@mui/material"
import { AddOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"

import { AssociateProductType } from "../../../types"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { Button } from "@/components/common/Button"
import { MIN_SEARCH_LENGTH } from "@/constants/common"

interface EmptyProductsStateProps {
  productType: AssociateProductType
  searchTerm: string
  onCreateCompetitor: () => void
}

export const EmptyProductsState: FC<EmptyProductsStateProps> = ({ productType, searchTerm, onCreateCompetitor }) => {
  // Only show create link for Competitor when searchTerm meets minimum length
  const showCreateLink = productType === AssociateProductType.Competitor && searchTerm.length >= MIN_SEARCH_LENGTH

  if (productType === AssociateProductType.Akrochem) {
    return (
      <Box className='flex justify-center py-8'>
        <Typography className='text-gray-500'>No products found for &quot;{searchTerm}&quot;</Typography>
      </Box>
    )
  }

  return (
    <Box className='flex flex-col gap-4 py-4'>
      <Typography className='mt-2 inline-flex align-middle text-sm leading-6'>
        <Typography className='inline-flex font-semibold text-gray-800'>0 products found</Typography>, Try adjusting
        your spelling or product type filter.
      </Typography>

      {showCreateLink && (
        <InformationMissingAlert
          icon={<WarningOutlined color='primary' />}
          title='Product not listed? Create it now in the Competitor Products tab.'
          titleClassName='text-primary'
          action={
            <Button
              color='inherit'
              size='small'
              appearance='outlined'
              className='text-primary'
              startIcon={<AddOutlined />}
              onClick={onCreateCompetitor}
              data-testid='create-competitor-product-button'
            >
              New Competitor Product
            </Button>
          }
          data-testid='empty-products-alert'
        />
      )}
    </Box>
  )
}
